export default __webpack_public_path__ + "static/media/9_1.87a431f1.jpg";